import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useAppDispatch} from '@/store'
import {setToastNotifications} from '@/store/slices/commonSlice'

export const useComboActions = () => {
    const {productCombo} = useProductCombo()
    const dispatch = useAppDispatch()
    const products = productCombo.comboSkus || []

    const navigate = useNavigate()

    const getProductStatus = () => {
        for ( let prod in products) {
            if (products[prod].status === 'Inactive') {
                return false
            }
        }
        return true
    }   

    const duplicateProductCombo = () => {
        const isActive = getProductStatus(productCombo.products)
        const duplicatedCombo = {
            ...productCombo,
            name: '', 
            productId: '',
            active: isActive,
        }

        dispatch(
            setToastNotifications({
                show: true,
                message: 'Combo duplicated successfully',
                type: 'success',
            })
        )

        navigate(ROUTES.CREATE_PRODUCT_COMBINATION, {
            state: {
                productCombo: duplicatedCombo,
                step: 1,
                isDuplicating: true,
            },
        })
    }   

    return {
        duplicateProductCombo,
        getProductStatus
    }
}